module.exports = __webpack_public_path__ + "img/20210906-1630910997145075.5aa1d206.jpg";